import { NgModule } from "@angular/core";
import { ModalHeaderComponent } from "./components/modal-header/modal-header.component";
import { CommonModule, DatePipe, NgOptimizedImage } from "@angular/common";
import { SnackBarTemplateComponent } from "./components/snack-bar-template/snack-bar-template.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { TimeAgoPipe } from "./pipe/time-ago.pipe";
import {
  BadgeInstallationStateComponent
} from "./components/badge-installation-state/badge-installation-state.component";
import { UserVisioStateComponent } from "./components/user-visio-state/user-visio-state.component";
import { ContactUsBlockComponent } from "./components/contact-us-block/contact-us-block.component";
import { RouterLink, RouterOutlet } from "@angular/router";
import { ManageRelativeDialog } from "./components/manage-relative/manage-relative.dialog";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatInputModule } from "@angular/material/input";
import { ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { ManagePictureComponent } from "./components/manage-picture/manage-picture.component";
import { OnboardingWrapperComponent } from "./wrappers/onboarding-wrapper/onboarding-wrapper.component";
import {
  OnboardingSubscriptionCardComponent
} from "./components/onboarding-subscription-card/onboarding-subscription-card.component";
import { OnboardingStepperComponent } from "./components/onboarding-stepper/onboarding-stepper.component";
import { OnboardingHeaderComponent } from "./components/onboarding-header/onboarding-header.component";
import { CouponFormComponent } from "./components/coupon-form/coupon-form.component";
import { OnboardingSummaryComponent } from "./components/onboarding-summary/onboarding-summary.component";

@NgModule({
  declarations: [
    ModalHeaderComponent,
    SnackBarTemplateComponent,
    BadgeInstallationStateComponent,
    TimeAgoPipe,
    UserVisioStateComponent,
    ContactUsBlockComponent,
    ManageRelativeDialog,
    ManagePictureComponent,
    OnboardingWrapperComponent,
    OnboardingSubscriptionCardComponent,
    OnboardingStepperComponent,
    OnboardingHeaderComponent,
    CouponFormComponent,
    OnboardingSummaryComponent
  ],
  exports: [
    ModalHeaderComponent,
    SnackBarTemplateComponent,
    TimeAgoPipe,
    BadgeInstallationStateComponent,
    UserVisioStateComponent,
    ContactUsBlockComponent,
    ManagePictureComponent,
    OnboardingWrapperComponent,
    OnboardingSubscriptionCardComponent,
    OnboardingStepperComponent,
    OnboardingHeaderComponent,
    CouponFormComponent,
    OnboardingSummaryComponent
  ],
  imports: [
    CommonModule,
    NgOptimizedImage,
    MatButtonModule,
    MatSnackBarModule,
    RouterLink,
    MatProgressSpinnerModule,
    MatInputModule,
    ReactiveFormsModule,
    MatTooltipModule,
    TranslateModule,
    RouterOutlet
  ],
  providers: [DatePipe]
})
export class SharedModule {
}
